import classes from "./Backdrop.module.css";
import cn from "classnames";

type Props = {
  openNav: boolean;
  onClickNav: () => void;
};
const Backdrop = ({ openNav, onClickNav }: Props) => {
  return (
    <div
      className={cn({ [classes.backDrop]: openNav })}
      onClick={onClickNav}
    ></div>
  );
};

export default Backdrop;
